import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "ticket-configuration__description"
}
const _hoisted_2 = {
  key: 1,
  class: "row mt-3 mt-md-5"
}
const _hoisted_3 = { class: "ticket-configuration__description col-md-6" }
const _hoisted_4 = { class: "ticket-configuration__description col-md-6 text-md-end" }
const _hoisted_5 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingSpinner = _resolveComponent("LoadingSpinner")!
  const _component_OptionBox = _resolveComponent("OptionBox")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_LoadingSpinner, { loading: _ctx.isLoading }, null, 8, ["loading"]),
    (!_ctx.hideTexts && _ctx.description !== false)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.description), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["ticket-configurations gy-3", _ctx.type !== 'b2b' ? 'row' : ''])
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["ticket-configuration__item", _ctx.type !== 'b2b' ? ' col-md-4' : ''])
      }, [
        _createVNode(_component_OptionBox, {
          title: _ctx.translate('shop.configuration.ticket.choose-one-of-the-following-options'),
          type: "radio",
          name: "options",
          isOptional: false,
          selectedOption: _ctx.selectedOption,
          onChangeOption: _ctx.onChangeOption,
          getPriceDifference: _ctx.getPriceDifferenceOptions,
          options: _ctx.options,
          selectedCurrency: _ctx.selectedCurrency
        }, null, 8, ["title", "selectedOption", "onChangeOption", "getPriceDifference", "options", "selectedCurrency"])
      ], 2),
      (_ctx.services.upgradesForOption?.length > 0)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["ticket-configuration__item", _ctx.type !== 'b2b' ? ' col-md-4' : ''])
          }, [
            _createVNode(_component_OptionBox, {
              title: _ctx.translate('shop.configuration.ticket.configure-ticket'),
              type: "checkbox",
              name: "upgrades[]",
              isOptional: true,
              selectedOption: _ctx.selectedUpgrades,
              onChangeOption: _ctx.onChangeUpgrades,
              onChange: _ctx.onUpgradeCheckboxChange,
              getPriceDifference: _ctx.getPriceDifferenceUpgrades,
              options: _ctx.services.upgradesForOption,
              selectedCurrency: _ctx.selectedCurrency
            }, null, 8, ["title", "selectedOption", "onChangeOption", "onChange", "getPriceDifference", "options", "selectedCurrency"])
          ], 2))
        : _createCommentVNode("", true),
      (_ctx.services.insuranceForOption?.length > 1)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: _normalizeClass(["ticket-configuration__item", _ctx.type !== 'b2b' ? ' col-md-4' : ''])
          }, [
            _createVNode(_component_OptionBox, {
              title: _ctx.translate('shop.configuration.ticket.configure-insurance'),
              type: "radio",
              name: "insurance",
              isOptional: true,
              selectedOption: _ctx.selectedInsurance,
              onChangeOption: _ctx.onChangeInsurance,
              getPriceDifference: _ctx.getPriceDifferenceInsurance,
              options: _ctx.services.insuranceForOption,
              selectedCurrency: _ctx.selectedCurrency
            }, null, 8, ["title", "selectedOption", "onChangeOption", "getPriceDifference", "options", "selectedCurrency"])
          ], 2))
        : _createCommentVNode("", true)
    ], 2),
    (!_ctx.hideTexts)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.translate('shop.configuration.ticket.for-more-infos-click-info-icon')), 1),
          _createElementVNode("div", _hoisted_4, [
            _createTextVNode(" *" + _toDisplayString(_ctx.translate('shop.configuration.ticket.prices-are-for-one')) + " ", 1),
            (_ctx.allPriceGroups.length > 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.allPriceGroups.filter((priceGroup) => priceGroup.value === _ctx.selectedPriceGroup)[0]?.label), 1))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}